<template>
    <div class="container">

        <!-- -------------------------- -->
        <!-- PANTALLA 0 LANGUAGE - PAIS -->
        <!-- -------------------------- -->
        <nav
            v-if="app.currentConfiguration.stage === 0"
            class="navbar navbar-expand-lg navbar-light bg-light my-2"
        >
            <strong style="color: grey">{{ $t('nav_titel_s0').toUpperCase() }}</strong>

            <i
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
                style="color: grey; cursor:pointer"
                class="fas fa-user-circle fa-2x"
            ></i>

            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav mr-auto">
                    <!-- Mis configuraciones -->
                    <li class="nav-item">
                        <router-link
                            to="/myConfigs"
                            class="nav-link"
                        >{{ $t('nav_titel_my_configs') }}</router-link>
                    </li>
                    <!-- idioma/mercado -->
                    <li class="nav-item active">
                        <router-link to="/0" class="nav-link">{{ $t('nav_titel_s0') }}</router-link>
                    </li>
                    <!-- login -->
                    <li class="nav-item" @click="app.auth.tryLogin()">
                        <a style="cursor:pointer" class="nav-link">{{ $t('register_login') }}</a>
                    </li>
                </ul>
            </div>
        </nav>

        <!-- -------------------------------- -->
        <!-- PANTALLA 1 SELECCIO CONFIGURADOR -->
        <!-- -------------------------------- -->
        <nav
            v-if="app.currentConfiguration.stage === 1"
            class="navbar navbar-expand-lg navbar-light bg-light my-2"
        >
            <strong style="color: grey">{{ $t('nav_titel_s1') }}</strong>

            <i
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
                style="color: grey; cursor:pointer"
                class="fas fa-user-circle fa-2x"
            ></i>

            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav mr-auto">
                    <li class="nav-item">
                        <!-- Mis configuraciones -->
                        <a class="nav-link" href="#">{{ $t('nav_titel_my_configs') }}</a>
                    </li>
                    <li class="nav-item">
                        <!-- idioma/mercado -->
                        <a class="nav-link" href="#">{{ $t('nav_titel_s0') }}</a>
                    </li>
                    <li class="nav-item">
                        <!-- login -->
                        <a class="nav-link" href="#">{{ $t('register_login') }}</a>
                    </li>
                </ul>
            </div>
        </nav>

        <!-- -------------------------------- -->
        <!--   PANTALLA 2, 3                  -->
        <!-- -------------------------------- -->
        <nav
            v-if="app.currentConfiguration.stage === 2 || app.currentConfiguration.stage === 3"
            class="navbar navbar-expand-lg navbar-light bg-light my-2"
        >
            <strong style="color: grey">{{ $t('nav_titel_s2') }}</strong>

            <i
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
                style="color: grey; cursor:pointer"
                class="fas fa-user-circle fa-2x"
            ></i>

            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav mr-auto">
                    <li class="nav-item">
                        <a class="nav-link" href="#">{{ $t('nav_titel_my_configs') }}</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" href="#">{{ $t('register_login') }}</a>
                    </li>
                </ul>
            </div>
        </nav>

        <!-- -------------------------------- -->
        <!--   PANTALLA 4                     -->
        <!-- -------------------------------- -->
        <nav
            v-if="app.currentConfiguration.stage === 4"
            class="navbar navbar-expand-lg navbar-light bg-light my-2"
        >
            <strong style="color: grey">{{ $t('nav_titel_s2') }}</strong>

            <i
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
                style="color: grey; cursor:pointer"
                class="fas fa-user-circle fa-2x"
            ></i>

            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav mr-auto">
                    <li class="nav-item">
                        <router-link
                            to="/saveConfiguration"
                            class="nav-link"
                        >{{ $t('nav_titel_my_configs') }}</router-link>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" href="#">{{ $t('nav_titel_save_config') }}</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" href="#">{{ $t('register_login') }}</a>
                    </li>
                </ul>
            </div>
        </nav>
    </div>
</template>


<style lang="scss">

</style>


<script>

import { app } from "../application.js";
export default {
    name: "navigationbarMobile",
    components: {},
    data() {
        return {
            app: app
        };
    },

    methods: {

    }
};
</script>





